import { useAppSelector } from "@/redux/store.ts";
import SearchBar from "./searchBar/SearchBar.tsx";
import UserDropdown from "./userDropdown/UserDropdown.tsx";
import Notifications from "./notifications/Notifications.tsx";
import { useGetPublicServicesQuery } from "@/redux/api/serviceApi.ts";
import { isAuth } from "@/utils/tokenServices.ts";
import styles from "./userDropdown/userDropdown.module.scss";
import headerStyles from "./header.module.scss";
import Logo from "../../views/common/icons/Logo.tsx";
import PinnedShortcuts from "./shortcuts/PinnedShortcuts.tsx";
import LanguageSelector from "./LanguageSelector.tsx";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useRef } from "react";
import { remapShortcutsTemp } from "@/utils/shortcutsUtils.ts";
import AgentToggle from "@/layout/agentChat/AgentToggle.tsx";

export const HeaderComponent = () => {
  const services = useAppSelector(state => state.layout.servicesList);
  const isAuthenticated = isAuth();
  const { data: publicServices = [] } = useGetPublicServicesQuery(undefined, { skip: isAuthenticated });

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    remapShortcutsTemp(services);
  }, [services]);

  return (
    <header>
      <div className={headerStyles.headerWrapper}>
        <div className={headerStyles.frameworkHeader}>
          <div ref={containerRef} className={headerStyles.headerContainerLeft}>
            <Tooltip
              slotProps={{
                popper: {
                  container: () => containerRef.current,
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [20, -30],
                      },
                    },
                  ],
                },
              }}
              classes={{ popper: headerStyles.tooltip }}
              title="OSTS"
              placement="bottom-end"
            >
              <div
                tabIndex={1}
                className={headerStyles.logo}
                onClick={() => window.location.replace(window.location.origin)}
              >
                <Logo />
              </div>
            </Tooltip>
            <div className={headerStyles.searchBar}>
              <SearchBar services={isAuthenticated ? services : publicServices} isAuthenticated={isAuthenticated} />
            </div>
          </div>
          <div className={styles.notificationsWrapper}>
            {isAuthenticated && (
              <>
                <AgentToggle />
                <PinnedShortcuts />
              </>
            )}
            <LanguageSelector />
            {isAuthenticated && <Notifications />}
            <UserDropdown />
          </div>
        </div>
      </div>
    </header>
  );
};

const Header = () => {
  return <HeaderComponent />;
};

export default Header;
